/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { GridCellBase } from "./GridCellBase";
import { markType } from "igniteui-react-core";
/**
 * @hidden
 */
var EditorRowCell = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(EditorRowCell, _super);
    function EditorRowCell(a) {
        var _this = _super.call(this, a) || this;
        _this.z.setRawStyleProperty("pointer-events", "none");
        return _this;
    }
    EditorRowCell.$t = markType(EditorRowCell, 'EditorRowCell', GridCellBase.$);
    return EditorRowCell;
}(GridCellBase));
export { EditorRowCell };
//# sourceMappingURL=EditorRowCell.js.map
